import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'next-i18next';
import styles from './mobile-pagination.module.scss';

interface PaginationProps {
  currentPage: number;
  pageCount: number;
  showScrollTop: boolean;
  handleNext: () => void;
  handlePrevious: () => void;
  centered?: boolean;
}

const MobilePagination = ({
  currentPage,
  pageCount,
  handleNext,
  handlePrevious,
  showScrollTop,
  centered,
}: PaginationProps) => {
  const { t: tA11y } = useTranslation('a11y');
  return (
    <>
      <div className={clsx(styles.pagination__container, centered && styles['pagination__container--centered'])}>
        <button
          className={styles.pagination__arrowButton}
          aria-label={tA11y('A11Y.ICON.ARROW_PREVIOUS')}
          onClick={handlePrevious}
          disabled={currentPage === 1}
        >
          <div className={clsx(styles.pagination__arrowIcon, styles.pagination__prevIcon)} />
        </button>
        <div className={styles.pagination__countContainer}>
          <span>
            {currentPage} / {pageCount}
          </span>
        </div>
        <button
          aria-label={tA11y('A11Y.ICON.ARROW_NEXT')}
          className={styles.pagination__arrowButton}
          onClick={handleNext}
          disabled={currentPage === pageCount}
        >
          <div className={clsx(styles.pagination__arrowIcon, styles.pagination__nextIcon)} />
        </button>
        {showScrollTop && (
          <button
            aria-label={tA11y('A11Y.ICON.ARROW_TOP')}
            className={styles.pagination__scrollTopButton}
            onClick={() => window.scrollTo({ top: 0, behavior: 'instant' })}
          >
            <div className={clsx(styles.pagination__arrowIcon, styles.pagination__upIcon)} />
          </button>
        )}
      </div>
    </>
  );
};

export default MobilePagination;
